import type { DicomInstanceInfo } from "./dicomMetadataLoader";

export interface ExpectedImageIdentity {
  studyUid: string;
  seriesUid?: string | null;
  frameNumber?: number | null;
}

/** Verify the decoded object's headers, as well as its metadata lookup. */
export function assertKeyImageIdentity(
  image: unknown,
  instance: DicomInstanceInfo,
  expected: ExpectedImageIdentity,
): void {
  const data = (image as { data?: { string?: (tag: string) => string | undefined } }).data;
  if (
    !data?.string ||
    data.string("x0020000d") !== expected.studyUid ||
    data.string("x00080018") !== instance.instance_uid ||
    (expected.seriesUid && data.string("x0020000e") !== expected.seriesUid)
  ) {
    throw new Error("Decoded image identity does not match the selected image.");
  }
  const frames = Number(data.string("x00280008") ?? "1");
  if (
    !Number.isInteger(frames) ||
    frames < 1 ||
    (frames > 1 && !expected.frameNumber) ||
    (expected.frameNumber && expected.frameNumber > frames)
  ) {
    throw new Error("The selected frame cannot be resolved unambiguously.");
  }
}
